import { TUser, IAuthenticatedUser } from '../../types/user';

export function isAuthenticatedUser(userForCheck: TUser): userForCheck is IAuthenticatedUser {
  return 'email' in userForCheck;
}
